import React, { useEffect, useState } from 'react'
import { Checkbox, CheckboxGroup, Col, Panel, Radio, RadioGroup, Rate, Row } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import MAndEWorkerForm from './MAndEWorkerForm'
import { DATE_FORMAT, DATE_PICKER_FORMAT } from '../../constants/date'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function MAndEFManageCBTeamForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  onSubmit = () => {},
  onCancel = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [startDate, setStartDate] = useState()

  useEffect(() => {
    if (_schema) {
      console.log('_schema', _schema)
      setFormSchema(_schema)
    }
  }, [_schema])

  return (
    <Panel
      shaded
      // collapsible
      // defaultExpanded
      header={<b>{formSchema?.header || ''}</b>}
      bordered
    >
      <Row style={{ marginTop: 10 }}>
        {formSchema?.preName && (
          <Col lg={4} md={4} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.preName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.firstName && (
          <Col lg={10} md={10} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.firstName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.lastName && (
          <Col lg={10} md={10} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.lastName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.position && (
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.position}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.mobileNumber && (
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.mobileNumber}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              isInputNumber={true}
              // onChange={(value, e) => {
              //   if (isNaN(value)) {
              //     return
              //   }
              //   props.onChange(value)
              // }}
            />
          </Col>
        )}

        {formSchema?.email && (
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.email}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.organization && (
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.organization}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}

        {formSchema?.expertise && (
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.expertise}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        )}
      </Row>

      <br />

      <SaveButton
        onClick={onSubmit}
        style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
      >
        บันทึก
      </SaveButton>

      <CancelButton
        onClick={onCancel}
        style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
      >
        ยกเลิก
      </CancelButton>
    </Panel>
  )
}
